import { cn, TabsContent, TabsList, TabsTrigger } from '@kalos/ui';
import { type ComponentProps } from 'react';

/**
 * The tab bar for switching sections of a record on phones (a project's Jobs / Notes / Office,
 * and the service job record's tabs once it moves over). Equal-width segments that grow to 44px
 * on touch, token colours only. Use inside `Tabs` from `@kalos/ui`. Each panel sits on the page
 * background, as a section of the record rather than a card of its own.
 */
export const RecordTabsList = ({ className, ...props }: ComponentProps<typeof TabsList>) => (
  <TabsList
    className={cn('bg-muted grid h-auto w-full auto-cols-fr grid-flow-col gap-1 p-1', className)}
    {...props}
  />
);

export const RecordTabsTrigger = ({ className, ...props }: ComponentProps<typeof TabsTrigger>) => (
  <TabsTrigger
    // Every segment has the same corners; the shared trigger rounds only the outer ends.
    className={cn('touch:min-h-11 min-h-9 text-sm first:rounded-md last:rounded-md', className)}
    {...props}
  />
);

export const RecordTabsContent = ({ className, ...props }: ComponentProps<typeof TabsContent>) => (
  <TabsContent className={cn('mt-4 rounded-none bg-transparent', className)} {...props} />
);
